import { Component, inject } from '@angular/core';
import { BaseWidgetComponent } from '../../../../../home/home-widgets/widgets/base-widget.component';
import { DriverOverviewService, FilterService } from '../../../../../_shared/services';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { OvertimeModalComponent } from '../../modals/overtime-modal/overtime-modal.component';
import { endOfDay, startOfMonth, subMonths, endOfMonth } from 'date-fns';
import { SummaryRequest } from '../../../../../_shared/models';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';
import { KpiWidgetComponent } from '../../../../../_shared/components/kpi-widget/kpi-widget.component';
import { CurrencyHelper } from '../../../../../_shared/helpers/currency/currency-map.helper';
import { AuthService } from '../../../../../_shared/services/auth.service';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-overtime-widget',
  standalone: true,
  imports: [KpiWidgetComponent, TranslocoPipe],
  templateUrl: './overtime-widget.component.html',
  styleUrl: './overtime-widget.component.scss',
})
export class OvertimeWidgetComponent extends BaseWidgetComponent {
  hasError: boolean = false;
  errorMessage: string = '';
  currencyCode: string = '';
  currencySymbol: string = '';

  private modalService = inject(NgbModal);
  private driverOverviewService = inject(DriverOverviewService);
  private errorHandlerService = inject(ErrorHandlerService);
  private auth = inject(AuthService);

  constructor() {
    const filterService = inject(FilterService);
    super(filterService);
    this.value = 0;
    this.percentageDifference = 0;
    this.difference = 0;
    this.isLoading = true;
    this.hasError = false;
    this.errorMessage = '';

    this.currencyCode = this.auth.getUserSettings()?.currencyCode ?? 'ZAR';
    this.currencySymbol = CurrencyHelper.getCurrencySymbol(this.currencyCode);
  }

  protected override async onFilterChangeAsync(): Promise<void> {
    this.hasError = false;
    this.isLoading = true;

    try {
      var currentDate = new Date();
      var previousDate = subMonths(currentDate, 1);
      let request: SummaryRequest = {
        accountIds: [...this.widgetFilter.accountIds],
        timeFrom: startOfMonth(currentDate),
        timeTo: endOfDay(currentDate),
        previousTimeFrom: startOfMonth(previousDate),
        previousTimeTo: endOfMonth(previousDate),
      }

      this.cancelSubject.next();
      const response = await this.driverOverviewService.getDriverOvertimeSummary(request, this.cancelSubject);
      this.value = response.data?.currentValue ?? 0;
      this.percentageDifference = response.data?.percentageDifference ?? 0;
      this.difference = response.data?.difference ?? 0;
      this.isLoading = false;
    } catch (error: any) {
      this.errorHandlerService.handleError(error, {
        callback: (message) => {
          this.errorMessage = message;
          this.hasError = true;
          this.isLoading = false;
        }
      });
    }
  }

  public override formatValue(value: number): string {
    return `${this.currencySymbol}${value.toLocaleString('default', { maximumFractionDigits: 2 })}`;
  }

  formatDifference(differenceSign: string, difference: number, percentageSign: string, percentage: number): string {
    return `${differenceSign}${this.currencySymbol}${difference.toLocaleString('default', { maximumFractionDigits: 2 })}` +
      `(${percentageSign}${percentage.toLocaleString('default', { maximumFractionDigits: 2 })}%)`;
  }

  public openOvertimeModal(): void {
    if (this.isLoading || this.hasError) return;
    
    const modalOptions: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    };

    const modalRef = this.modalService.open(OvertimeModalComponent, modalOptions);
    modalRef.componentInstance.widgetFilter = this.widgetFilter;
  }
}